import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { env, python } from 'src/environments/environment';
import { Notifications } from '../interfaces/interfaces.model';
import { AuthService } from 'src/app/core/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  // private readonly apiWeb2: string = `${env.url_base}${env.api}${env.landing}${env.perfil_usuario}${env.module.api_perfilUser_end}`;
  private readonly apiWeb2 = `${python.url_base}`;// 'http://10.51.20.5:5001/ask';

  // Nuevo BehaviorSubject para manejar el estado de notificaciones sin leer
  private notificacionesSinLeerSubject = new BehaviorSubject<boolean>(false);
  public notificacionesSinLeer$ = this.notificacionesSinLeerSubject.asObservable();

  constructor(private http: HttpClient, private authService: AuthService) { }

  getNotifications(id_ciud: number): Observable<Notifications[]> {
    const endpoint = `${this.apiWeb2}/getNotifications/${id_ciud}`;

    return this.authService.performProtectedRequest(() =>
      this.http.get<Notifications[]>(
        endpoint,
        {
          withCredentials: true,
        }
      )
    );
  }

  updateNotificationReadState(notificationId: number, userId: number): Observable<Notifications> {
    const endpoint = `${this.apiWeb2}/updateNotificationReadState`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.authService.performProtectedRequest(() =>
      this.http.post<Notifications>(
        endpoint,
        { notificationId, userId },
        {
          headers,
          withCredentials: true,
        }
      )
    );
  }

  updateAllNotificationsReadState(userId: number): Observable<Notifications> {
    const endpoint = `${this.apiWeb2}/updateAllNotificationsReadState`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.authService.performProtectedRequest(() =>
      this.http.post<Notifications>(
        endpoint,
        { userId },
        {
          headers,
          withCredentials: true,
        }
      )
    );
  }

  // Nuevo método para actualizar el estado de notificaciones sin leer
  actualizarEstadoNotificacionesSinLeer(tieneSinLeer: boolean): void {
    this.notificacionesSinLeerSubject.next(tieneSinLeer);
  }

  // Nuevo método para verificar notificaciones sin leer (opcional)
  verificarNotificacionesSinLeer(userId: number): void {
    this.getNotifications(userId).subscribe({
      next: (response: any) => {
        if (response && Array.isArray(response.logs)) {
          const hayNotificacionesSinLeer = response.logs.some((log: any) => !log.leida);
          this.actualizarEstadoNotificacionesSinLeer(hayNotificacionesSinLeer);
        } else if (Array.isArray(response)) {
          // Si la respuesta ya es un array (dependiendo de la estructura de tu API)
          const hayNotificacionesSinLeer = response.some((notificacion: any) => !notificacion.leida);
          this.actualizarEstadoNotificacionesSinLeer(hayNotificacionesSinLeer);
        }
      },
      error: (err) => {
        console.error('Error al verificar notificaciones sin leer:', err);
      }
    });
  }
}
